import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { Edit, Add } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';

import { wsFindBy } from 'services/WService';
import { WithApp } from 'contexts/appContext';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import ButtonDelete from 'hooks/ButtonDelete';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Documento', accessor: 'document' },
  { Header: 'Serie', accessor: 'serie' },
  { Header: 'Usuario creado', accessor: 'createUser' },
  { Header: 'Usuario Actualizado', accessor: 'updateUser' },
  { Header: 'Activo', accessor: 'active' },
  { Header: '', accessor: 'actions' }
];

export default WithApp(function DocumnetSerie(props) {
  const classes = useStyles();
  const idDocumentP = props.idDocumentP;

  const [model, setOpen] = useModal(); //uso de las funciones del modal

  const [documentSeries, setDocumentSeries] = useState([]);

  async function listDocumentSeries() {
    let response = await wsFindBy('prt/document-serie-permission', {
      document: idDocumentP,
      oauth_user_id: props.idUser
    });
    if (response.success) setDocumentSeries(response.data);
  }

  useEffect(() => {
    if (idDocumentP !== undefined) {
      listDocumentSeries();
    }
  }, [idDocumentP]);

  return (
    <>
      <Modal
        model={model}
        setOpen={setOpen}
        showNotify={props.showNotify}
        reload={listDocumentSeries}
        idDocumentP={idDocumentP}
        idUser={props.idUser}
      />
      <Card>
        <CardHeader icon>
          <CardIcon
            onClick={() => setOpen({})}
            pointer="true"
            color={props.themeContext.buttonColorSuccess}
          >
            <Add />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de serie del documento ({idDocumentP})</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            defaultWidth={1200}
            indexRow={[0, 6]}
            widthRow={[150, 5]}
            columns={columns}
            data={documentSeries.map((docSerie, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard
                      permission={ConstantPermissions.PRT_DOCUMENT_SERIE_PERMISSIONS_UPDATE}
                    >
                      <Button
                        justIcon
                        round
                        simple
                        color={props.themeContext.buttonColorWarning}
                        onClick={() => setOpen(docSerie)}
                      >
                        <Edit />
                      </Button>
                    </AllowedGuard>
                    <AllowedGuard
                      permission={ConstantPermissions.PRT_DOCUMENT_SERIE_PERMISSIONS_DELETED}
                    >
                      <ButtonDelete
                        entity="prt/document-serie-permission"
                        id={docSerie.id}
                        reload={listDocumentSeries}
                      />
                    </AllowedGuard>
                  </div>
                ),
                document: docSerie.document,
                serie: docSerie.serie,
                createUser: docSerie.createUser,
                updateUser: docSerie.updateUser,
                active: docSerie.active === 'Y' ? 'Si' : 'No',
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
